// extracted by mini-css-extract-plugin
module.exports = {"container":"AcademicPoint_container__YGBdM"};